import { component } from 'picoapp'

export default class Modal {
  constructor() {
    // bindings
    this.activateModal = this.activateModal.bind(this)
    this.suspendModal = this.suspendModal.bind(this)
    this.clickToClose = this.clickToClose.bind(this)

    // privates
    this._modal = document.getElementById('modal')
  }

  clickToClose(e) {
    let id = e.target.id

    if (id === 'modal-inner' || id === 'modal-close-btn') {
      this.suspendModal()
    }
  }

  activateModal() {
    document.body.classList.add('lock')
    this._modal.style.display = 'block'
    this._modal.offsetHeight
    this._modal.classList.add('show')
    this._modal.addEventListener('click', this.clickToClose)
  }

  suspendModal() {
    document.body.classList.remove('lock')
    this._modal.removeEventListener('click', this.clickToClose)
    this._modal.offsetHeight
    this._modal.classList.remove('show')
    setTimeout(() => {
      this._modal.style.display = 'none'
    }, 666)
  }
}
